export type TAX_REGION = 'AU' | 'NZ';

const financialYearStartMonth: Record<TAX_REGION, number> = {
  AU: 7,
  NZ: 4,
};

const getFinancialYearsFromDate = (startDate: Date, region: TAX_REGION) => {
  const startMonth = financialYearStartMonth[region];
  const currentDate = new Date();

  const years: string[] = [];

  let year = startDate.getFullYear();
  let startOfFinancialYear = new Date(year, startMonth - 1, 1);

  // Adjust the start year if the start date is after the financial year's start month
  if (startDate > startOfFinancialYear) {
    year++;
  }

  while (startOfFinancialYear <= currentDate) {
    years.push(`${year}_${year + 1}`);
    year++;
    startOfFinancialYear = new Date(year, startMonth - 1, 1);
  }

  return years;
};

export { getFinancialYearsFromDate, financialYearStartMonth };
